import { Dispatch, SetStateAction } from "react";
import { InputMobile, LabelMobile, MergeLabelAndInputMobile } from "../../../../components/Input-Mobile/InputAndLabelMobile";
import { convertDate, _formatDate } from "../../../../libs/dateUtils";
import { TitleMobile } from "../components/TitleMobile";

type ITimesheetFilterMobile = {
  setPage?: any;
  dateTo: string;
  dateFrom: string;
  setDateTo: Dispatch<SetStateAction<any>>;
  setDateFrom: Dispatch<SetStateAction<any>>;
  getPointsRange: (dateFrom: string, dateTo: string) => void;
};

export function TimeSheetFilterMobile({ setPage, dateTo, dateFrom, setDateTo, setDateFrom, getPointsRange }: ITimesheetFilterMobile) {
  return (
    <>
      <div className="h-full">
        <TitleMobile onClick={setPage} title="Filtrar datas:" />
        <div className="flex justify-center items-center h-4/5 -mx-8 bg-primary p-8 table-mobile-timesheet">
          <div className="flex flex-col bg-white rounded-3xl shadow-2xl box-filter justify-evenly">
            <MergeLabelAndInputMobile>
              <LabelMobile children="Data Inicial" className="-ml-4" />
              <InputMobile className="input-date-mobile" type="date" value={_formatDate(dateFrom)} onChange={(e) => setDateFrom(e.target.value)} />
            </MergeLabelAndInputMobile>
            <MergeLabelAndInputMobile>
              <LabelMobile children="Data Final" className="-ml-4" />
              <InputMobile className="input-date-mobile" type="date" value={_formatDate(dateTo)} onChange={(e) => setDateTo(e.target.value)} />
            </MergeLabelAndInputMobile>
          </div>
        </div>
        <div className="flex h-1/6 items-center justify-between w-full px-14">
          <button onClick={() => setPage("homepage")} className="bg-secondary h-20 w-2/5 rounded-2xl text-2rem font-familyPoppins shadow-2xl -mb-8">
            Cancelar
          </button>
          <button
            onClick={() => {
              getPointsRange(_formatDate(dateFrom, ["-", "/"]), _formatDate(dateTo, ["-", "/"]));
              setPage("homepage");
            }}
            className="bg-primary h-20 w-2/5 rounded-2xl text-2rem font-familyPoppins shadow-2xl -mb-8"
          >
            Filtrar
          </button>
        </div>
      </div>
    </>
  );
}
